import type { Brand } from "core/entities";
import { createContext } from "react";

export const BrandContext = createContext<Brand | null>(null);
